import React from 'react';
import PropTypes from 'prop-types';
import { Field } from 'formik';

import './NumberAnswer.less';

export function NumberAnswer({ error, question }) {
  let placeholder;

  if (question.answer_min) {
    placeholder = `Enter number (${question.answer_min} min.)`;
  }

  if (question.answer_max) {
    placeholder = `Enter number (${question.answer_max} max.)`;
  }

  if (question.answer_min && question.answer_max) {
    placeholder = `Enter number (${question.answer_min} - ${question.answer_max})`;
  }

  const step = question.question_type === 'integer' ? 1 : 0.1;

  // implement the legacy validation which was the following:
  // https://jqueryvalidation.org/min-method/
  // https://jqueryvalidation.org/max-method/
  // app/js/apps/question-display/index.js
  // https://jqueryvalidation.org/number-method/
  const handleValidate = (value) => {
    // for formik validation: return string error message if invalid, undefined if valid

    // copying over parsing logic from app/js/apps/question-display/index.js
    // question.answer_min and question.answer_max are strings
    const minNum = parseFloat(question.answer_min);
    const maxNum = parseFloat(question.answer_max);

    // implementing https://jqueryvalidation.org/number-method/ would be some complicated regex expression
    // i think parseFloat is sufficient
    if (value && !parseFloat(value)) {
      return 'Please enter a valid number.';
    }

    const parsedValue = parseFloat(value);

    if (minNum && parsedValue < minNum) {
      return `Please enter a value greater than or equal to ${minNum}`;
    }
    if (maxNum && parsedValue > maxNum) {
      return `Please enter a value less than or equal to ${maxNum}`;
    }

    return undefined;
  };

  return (
    <Field
      autoComplete="off"
      className={`number_answer ${error ? 'error' : ''}`}
      id={question.question_id}
      max={question.answer_max}
      min={question.answer_min}
      name="answer"
      placeholder={placeholder}
      // required={!!question.is_required}
      step={step}
      type="number"
      validate={handleValidate}
    />
  );
}

NumberAnswer.propTypes = {
  error: PropTypes.string,
  question: PropTypes.shape({
    answer_max: PropTypes.string,
    answer_min: PropTypes.string,
    is_required: PropTypes.bool,
    question_id: PropTypes.number,
    question_type: PropTypes.oneOf(['decimal', 'integer']),
  }).isRequired,
};

NumberAnswer.defaultProps = {
  error: '',
};

export default NumberAnswer;
